import ApiService from '@/services/api.service';

const TestOrderResultSetupService = {
    getAllListing(parameters) {
        return ApiService.getWithArray('/PatientTestResultSetups/', parameters);
    },

    add(data) {
        return ApiService.post(`/PatientTestResultSetups`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientTestResultSetups/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientTestResultSetups/${id}`, data);
    },

    get(id) {
        return ApiService.get(`/PatientTestResultSetups/${id}`);
    },
};

export default TestOrderResultSetupService;
